import React from 'react';
import { Link } from 'react-router-dom';
import SocialBtns from '../SocialBtns/SocialBtns';
import styles from './Footer.module.css';
import logo from '../../assets/footerLogo.svg';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer} id="footer">
            <div className={styles.footerMain}>

                {/* Left Side: Brand & Socials */}
                <div className={styles.footerBrand}>
                    <Link to="/" className={styles.footerLogo} onClick={() => window.scrollTo(0, 0)}>
                        <img src={logo} alt="FasBeam Official Logo" />
                    </Link>
                    <div className={styles.socialsWrapper}>
                        <SocialBtns />
                    </div>
                </div>

                {/* Right Side: Grouped Links */}
                <div className={styles.footerLinksGroup}>
                    
                    {/* Navigation */}
                    <div className={styles.footerLinks}>
                        <h3 className={styles.sectionTitle}>NAVIGATION</h3>
                        <ul>
                            <li><Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link></li>
                            <li><Link to="/socials" onClick={() => window.scrollTo(0, 0)}>Socials</Link></li>
                            <li><Link to="/consultancy" onClick={() => window.scrollTo(0, 0)}>Consultancy</Link></li>
                        </ul>
                    </div>

                    {/* Partners */}
                    <div className={styles.footerLinks}>
                        <h3 className={styles.sectionTitle}>PARTNERS</h3>
                        <ul>
                            <li>
                                <a href="https://www.caradvice.in/" target="_blank" rel="noopener noreferrer" className={styles.externalLink}>
                                    CarAdvice <span>&#8599;</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://fk-r.com/" target="_blank" rel="noopener noreferrer" className={styles.externalLink}>
                                    FK-R <span>&#8599;</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Location */}
                    <div className={styles.footerLocation}>
                        <h3 className={styles.sectionTitle}>WHERE ARE WE?</h3>
                        <address className={styles.address}>
                            Navi Mumbai, Maharashtra
                        </address>
                    </div>

                </div>
            </div>

            {/* Bottom Bar: Copyright */}
            <div className={styles.footerBottom}>
                <p>&copy; {currentYear} FasBeam. All Rights Reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;



//Remove completed address
//    Office No. 1706, 17th Floor,<br />
//                         Fairmount Building,<br />
//                         Plot No. 4 & 6, Sector 17, Sanpada,<br />